import React from 'react'
import { Button } from '@components/Basic/ButtonNbe'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

interface Props {
  onCancelRequest?: () => void
  isLoading: boolean
}

const CreditCardActionButtons = styled.div`
  display: flex;
  max-width: 500px;
  gap: 2rem;
  padding: 0 2rem 2rem;
  margin-top: -0.5rem;
`

export const CreditCardSubmitButtons: React.FC<Props> = ({
  onCancelRequest,
  isLoading,
}) => {
  const { t } = useTranslation()

  return (
    <CreditCardActionButtons>
      <Button
        $variant={'action'}
        type={'submit'}
        disabled={isLoading}
        $loading={isLoading}
      >
        {t('common.save')}
      </Button>

      {onCancelRequest ? (
        <Button
          type={'button'}
          onClick={onCancelRequest}
          $variant={'link-secondary'}
        >
          {t('common.cancel')}
        </Button>
      ) : null}
    </CreditCardActionButtons>
  )
}
